module.exports = __webpack_public_path__ + "static/media/master.fb0efb16.svg";